<table *ngIf="auths && auths.length > 0" class="table table-hover">
    <thead [ngStyle]="{ backgroundColor: 'var(--cf-brand-dark)', color: '#fff' }">
        <tr>
            <th scope="col">Cliente</th>
            <th scope="col">CIF/NIF</th>
            <th scope="col">Fecha solicitud</th>
            <th scope="col">Fecha validada</th>
            <th scope="col">Fecha revocada</th>
            <th scope="col">Validada</th>
            <th scope="col">Revocada</th>
            <th scope="col">Acciones</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let auth of auths; trackBy: trackByIndex">
            <td>{{ auth.name }}</td>
            <td>{{ auth.vatNumber }}</td>
            <td>{{ auth.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ auth.validatedDate | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ auth.revokedDate | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>
                <span *ngIf="auth.validatedDate; else noVal" class="badge bg-success">Sí</span>
                <ng-template #noVal><span class="badge bg-warning">No</span></ng-template>
            </td>
            <td>
                <span *ngIf="auth.revokedDate; else noRev" class="badge bg-danger">Sí</span>
                <ng-template #noRev><span class="badge bg-warning">No</span></ng-template>
            </td>
            <td>
                <button class="btn btn-convfact btn-outline-primary btn-sm me-1" (click)="downloadAuthorization(auth.uid)" style="margin-right: 10px;">
                    Descargar
                </button>
                <button class="btn btn-success btn-sm me-1" *ngIf="!auth.validatedDate && !auth.revokedDate"
                    (click)="validateAuthorization(auth.uid)" style="margin-right: 10px;">
                    Validar
                </button>
                <button class="btn btn-danger btn-sm" *ngIf="!auth.revokedDate" (click)="revokeAuthorization(auth.uid)">
                    Revocar
                </button>
            </td>
        </tr>
    </tbody>
</table>